<template>
  <div>
    <div class="circles" :style="{left:left,top:top}">
    </div>
  </div>

</template>

<script>
export default {
  name: "Circles",
  props: {
    left: {
      type: String,
      default: "50%"
    },
    top: {
      type: String,
      default: "50%"
    },
  }
};
</script>
<style lang="scss" scoped>
.circles{
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: rgb(38, 157, 156);
  z-index: 99;
}
</style>
